
import { Component, Mixins } from "vue-property-decorator";
import AuthenticateMixin from "../../common/mixins/auth.mixin";
import OfficeProfilesMixin from "./office-profiles.mixin";
import OfficeProfilesCard from "./components/office-profiles-card.vue";
import { mapState } from "vuex";
import { PracticeFormDto } from "@/types/practice.type";
import { OfficeProfileDto } from "@/types/office.type";

interface PracticeNameInputRef extends Element {
  focus(): void;
}

@Component({
  components: {
    OfficeProfilesCard,
  },
  computed: {
    ...mapState("OfficeProfile", ["practiceName"])
  }
})
export default class OfficeProfilesComponent extends Mixins(OfficeProfilesMixin, AuthenticateMixin) {
  newPracticeName = "";
  practiceName!: string;
  isPracticeEdit = false;
  columnCount = 3;
  officeNameFilter = "";

  officeColorPalette = [
    "#005F73",
    "#229597",
    "#007C91",
    "#315564",
    "#1D3557",
    "#2F3C46",
    "#284B63",
    "#007BFF",
    "#777777"
  ];

  get columnStyle(): string {
    return `width: ${100 / this.columnCount}%;`;
  }

  get filteredOfficeProfiles(): OfficeProfileDto[][] {
    const offices = this.officeProfiles
      .filter(office => office.officeName.toLowerCase().includes(this.officeNameFilter.toLowerCase()));
    
    const splitOfficeProfiles: OfficeProfileDto[][] = [];
    
    let currentColumn = 0;

    offices.forEach((officeProfile, index) => {
      if (!splitOfficeProfiles[currentColumn]) {
        splitOfficeProfiles[currentColumn] = [];
      }

      splitOfficeProfiles[currentColumn].push(officeProfile);

      if (currentColumn > 0 && currentColumn % (this.columnCount - 1) === 0) {
        currentColumn = 0;

        return;
      }

      currentColumn++;
    });
    
    return splitOfficeProfiles;
  }

  get isPracticeNameValid(): boolean {
    return this.newPracticeName != null && 
      this.newPracticeName.length > 0 && 
      this.newPracticeName.length < 256;
  }

  async mounted(): Promise<void> {
    this.setLoading(true);

    await this.$store.dispatch("OfficeProfile/getOfficeProfiles", this.userInfo()?.practiceId);
    await this.$store.dispatch("OfficeProfile/getOfficeUserData");

    this.setLoading(false);
  }

  getOfficeColor(columnIndex: number, rowIndex: number): string {
    const index = rowIndex * this.columnCount + columnIndex;
    const paletteIndex = index % this.officeColorPalette.length

    return this.officeColorPalette[paletteIndex];
  }

  clearFilter(): void {
    this.officeNameFilter = "";
  }

  toggleEdit(): void {
    this.newPracticeName = this.practiceName;
    this.isPracticeEdit = true;

    (this.$refs.practiceNameInput as PracticeNameInputRef).focus();
  }

  async submit(): Promise<void> {
    const userInfo = this.userInfo();

    if (!this.isPracticeNameValid || !userInfo || !userInfo.practiceId) {
      return;
    }

    const form: PracticeFormDto = {
      id: userInfo.practiceId,
      practiceName: this.newPracticeName
    };

    await this.$store.dispatch("OfficeProfile/savePractice", form);

    this.isPracticeEdit = false;
  }

  toOfficeCreate(): void {
    this.$store.commit("OfficeProfile/updateField", {
      path: "selectedOffice",
      value: null
    });

    this.$store.commit("OfficeProfile/updateField", {
      path: "isEdit",
      value: false
    });
    
    this.$router.push("/office-profiles-edit");
  }
}
